<div class="modal-header"><h2 class="modal-title">Settings</h2></div>
<div class="modal-body">
  @if (ready) {
    <div class="m-2">
      <dx-form [formData]="ready">
        <dxi-item [label]="{ text: 'Required Deacons' }">
          <div *dxTemplate>
            <dx-number-box [(value)]="requiredDeacons"> </dx-number-box>
          </div>
        </dxi-item>
        <dxi-item [label]="{ text: 'Required Executive Elders' }">
          <div *dxTemplate>
            <dx-number-box [(value)]="requiredExecutive"> </dx-number-box>
          </div>
        </dxi-item>
        <dxi-item [label]="{ text: 'Required Shepherding Elders' }">
          <div *dxTemplate>
            <dx-number-box [(value)]="requiredShepherding"> </dx-number-box>
          </div>
        </dxi-item>
      </dx-form>
    </div>
  }

</div>
<div class="modal-footer">
  <button type="button" class="btn btn-success" (click)="save()">Save</button>
  <button type="button" class="btn btn-primary" (click)="close()">Close</button>
</div>
